export default __webpack_public_path__ + "Kimi778e37.svg";